import { render, staticRenderFns } from "./MemberSettingsView.vue?vue&type=template&id=24c622b6&scoped=true"
import script from "./MemberSettingsView.vue?vue&type=script&lang=js"
export * from "./MemberSettingsView.vue?vue&type=script&lang=js"
import style0 from "./MemberSettingsView.vue?vue&type=style&index=0&id=24c622b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c622b6",
  null
  
)

export default component.exports